import React from "react";
import PropTypes from "prop-types";
import "./SearchBar.scss";
import { HiSearch } from "react-icons/hi";
/**
 * Barre de recherche dans tout le site
 */
// TO DO : intégrer la barre de recherche
const SearchBar = (props) => {
  return (
    <div className="searchBar">
      <h2 className="searchBar__title">
        COMMENT VOUS AIDER AUJOURD&apos;HUI ?
      </h2>
      <div className="searchBar__bar">
        <HiSearch
          className="searchBar__bar__icon"
          onClick={() => {
            if (props.filtreMotsCles.length > 2) {
              props.handleFilter(props.filtreMotsCles);
            }
          }}
        />
        <input
          type="text"
          className="searchBar__bar__input"
          placeholder="Rechercher un emploi, découvrir les prochains événements..."
          value={props.filtreMotsCles}
          onChange={(e) => {
            props.setFiltreMotsCles(e.target.value);
            if (e.target.value === "") props.handleFilter(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && props.filtreMotsCles.length > 2) {
              props.handleFilter(props.filtreMotsCles);
            }
          }}
        />
      </div>
    </div>
  );
};
SearchBar.propTypes = {
  handleFilter: PropTypes.func,
  filtreMotsCles: PropTypes.string,
  setFiltreMotsCles: PropTypes.func,
};
export default SearchBar;
